import axios from "axios";
import { dispatchSDK, dispatchToast } from "./extend";

const service = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
});

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const extendParams = config.params || {};
    extendParams.token = token;
    config.params = extendParams;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const { data, config } = response;
    const { code, msg } = data;
    const { url } = config;
    if (code === 401 && url !== "/my/task") {
      dispatchToast.warning("登录凭证已过期");
      dispatchSDK("loginFailure");
      return Promise.reject();
    }
    if (code !== 200 && code !== 201 && url !== "/my/task") {
      setTimeout(() => {
        dispatchToast.warning(msg || "请求出错");
      }, 0);
      return Promise.reject();
    }
    if (code === 201) {
      setTimeout(() => {
        dispatchToast.show(msg || "成功");
      }, 0);
    }
    return data;
  },
  (error) => {
    setTimeout(() => {
      dispatchToast.warning("网络出错");
    }, 0);
    return Promise.reject(error);
  }
);

export default service;
